import { Pipe, PipeTransform } from '@angular/core';
import isNil from 'lodash/isNil';

const KM_PER_MILE: number = 1.609344; // 1 mile = 1.609344 km

@Pipe({ name: 'ev-economy' })
export class EvEconomyPipe implements PipeTransform {
  public transform(energy: number, userMetricUnits: boolean, reverse: boolean = false, decimalPlaces: number = 1): string {
    // reverse: true = convert km/kwh to mile/kwh, false = convert kwh/km to kwh/mile
    if (isNil(energy)) return null;

    if (userMetricUnits) {
      return energy.toFixed(decimalPlaces);
    } else {
      if (reverse) {
        // convert km/kwh to mile/kwh
        return (energy / KM_PER_MILE).toFixed(decimalPlaces);
      } else {
        // convert kwh/km to kwh/mile
        return (energy * KM_PER_MILE).toFixed(decimalPlaces);
      }
    }
  }
}

